import { computed, onBeforeUnmount, onMounted, ref } from "vue";

const hubspotOverlayIdPrefix = "hs-overlay-cta-";
const hasHubspotOverlay = ref(false);

let observer: MutationObserver | null = null;
let subscribersCount = 0;

const updateHasHubspotOverlay = (): void => {
    if (typeof document === "undefined") {
        hasHubspotOverlay.value = false;
        return;
    }

    hasHubspotOverlay.value =
        document.querySelector(`[id^="${hubspotOverlayIdPrefix}"]`) !== null;
};

const startObserver = (): void => {
    if (observer !== null) {
        return;
    }

    updateHasHubspotOverlay();

    if (typeof MutationObserver === "undefined" || !document.body) {
        return;
    }

    observer = new MutationObserver(updateHasHubspotOverlay);
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
};

const stopObserver = (): void => {
    observer?.disconnect();
    observer = null;
    hasHubspotOverlay.value = false;
};

export const useHubspotOverlay = () => {
    onMounted(() => {
        subscribersCount += 1;
        startObserver();
    });

    onBeforeUnmount(() => {
        subscribersCount = Math.max(0, subscribersCount - 1);

        if (subscribersCount === 0) {
            stopObserver();
        }
    });

    return {
        hasHubspotOverlay: computed(() => hasHubspotOverlay.value),
    };
};
